/**
 * AdminPerfilPage — /admin/perfil
 * Renders PerfilContent inside the AdminLayout Outlet so the admin rail stays
 * visible. Navigates to /admin/manual for the "Ver manual" action.
 */
import { useNavigate } from "react-router-dom";
import { PerfilContent } from "@/features/account/index.js";

const labelClass =
  "font-mono text-[0.625rem] font-medium uppercase tracking-[0.18em] text-muted-foreground";

export function AdminPerfilPage() {
  const navigate = useNavigate();
  return (
    <main className="mx-auto w-full max-w-3xl px-6 py-8 md:px-8 md:py-10">
      <div className="mb-8 space-y-1">
        <p className={labelClass}>Administración</p>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-foreground">
          Mi perfil
        </h1>
      </div>
      <PerfilContent onVerManual={() => navigate("/admin/manual")} />
    </main>
  );
}
